// At lower/upper circuit the opposite side of the book is often 0.
// Use LTP for display and unrealized PnL in that case only.
export function markPriceAtCircuit(price, ltp, lowerCircuit, upperCircuit) {
  if (!(Number(price) === 0)) return price;

  const last = Number(ltp);
  if (!(last > 0)) return price;

  const lower = Number(lowerCircuit);
  const upper = Number(upperCircuit);
  const atLower = lower > 0 && last <= lower;
  const atUpper = upper > 0 && last >= upper;
  if (atLower || atUpper) return last;

  return price;
}
